import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';
import { CampaignPriceOffer, OmaLummeCampaign } from '../types/contract';

export const getCampaignPriceOffers = async (dataOwnerCustomerId: number, lang: string): Promise<CampaignPriceOffer[] | undefined> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  try {
    const campaignPriceOffers: AxiosResponse<CampaignPriceOffer[]> = await API({
      method: 'post',
      url: `/v1/campaignPriceoffers/${dataOwnerCustomerId}`,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
      data: {
        content,
        lang,
      },
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          logUserOut();
        }
        if (error.response.status === 400) {
          return undefined;
        }
        return error.response;
      }
    });

    return campaignPriceOffers.data;
  } catch {}

  return undefined;
};
export const getCampaignOmaLummePrices = async (campaignIds: number): Promise<OmaLummeCampaign[] | undefined> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  try {
    const omaLummePrices: AxiosResponse<OmaLummeCampaign[]> = await API({
      method: 'post',
      url: `/v1/campaignOmaLummePrices/${campaignIds}`,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
      data: {
        content,
      },
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          logUserOut();
        }
        return error.response;
      }
    });

    return omaLummePrices.data;
  } catch {}

  return undefined;
};
